/**
 * New Job page
 * Create new scraping job wizard
 */

import { PageHeader } from '@/components/common/PageHeader';
import { JobWizard } from '@/components/new-job';

export function NewJobPage() {
  return (
    <div>
      <PageHeader
        title="Create New Job"
        breadcrumbs={[
          { label: 'Dashboard', path: '/' },
          { label: 'Jobs', path: '/jobs' },
          { label: 'New Job' },
        ]}
      />

      <JobWizard />
    </div>
  );
}

export default NewJobPage;
